import { useNavigate } from 'react-router-dom';
import { EventManagerNavigation } from '@components/event-manager-navigation';
import { useAndroidSwipeRefresh } from '@hooks/use-android-swipe-refresh/use-android-swipe-refresh';

import { Props } from '../../layout.type';

export const LayoutEvents = ({ children }: Props) => {
  // The editor has no scroll container, so no touch here can enable pull-to-refresh.
  useAndroidSwipeRefresh({ initialEnabled: false });
  const navigate = useNavigate();
  return <EventManagerNavigation navigateTo={navigate}>{children}</EventManagerNavigation>;
};
